import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const styles = theme => ({
  root: { paddingBottom: 10 },
  header: {}
})

class ToolsHeader extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const { classes } = this.props

    return (
      <div className={classes.root}>
        <Typography className={classes.header} variant="h6">Tools</Typography>
        <Typography className={classes.header} variant="body1">Query, build and share maps.</Typography>
      </div>
    )
  }
}

ToolsHeader.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps (state, ownProps) {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ToolsHeader)
  )
)
